const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/nativeAppQRCodeScanner.ts';
import { theme } from 'App/utils/clientSetupManager';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';
import { Action } from 'redux';

export const REQUEST_ACTION_TYPES_GET_PATAPP_QRCODE = kisapiActionTypes('NATIVE_PATAPP_QRCODE');

export interface QRCodeProps {
    title: string;
    backBtnText: string;
    textColor: string;
    backgroundColor: string;
    backgroundColorBtn: string;
}

export interface IQRCAction extends Action {
    payload: { regex: string; qrcProps: QRCodeProps };
}

export function dispatchPatappQRCodePending(regex: string, title: string, backBtnText: string): IQRCAction {
    return {
        type: REQUEST_ACTION_TYPES_GET_PATAPP_QRCODE.pending,
        payload: {
            regex,
            qrcProps: {
                title,
                backBtnText,
                textColor: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
                backgroundColorBtn: theme.palette.primary.main,
            },
        },
    };
}
